import axios from 'axios';

export default function() {
  return {
    namespaced: true,
    state: {
      menu: {},
    },
    mutations: {
      SET_MENU(state, { data, locale }) {
        // TODO: data validation
        state.menu = {
          ...state.menu,
          [locale]: data,
        }
        // state.menu[locale] = data;
      },
    },
    actions: {
      FETCH_MENU({ state, commit }, { locale }) {
        if (state.menu[locale]) return;

        return axios.get(encodeURI(`/api/travelessential/menu`))
          .then((res) => {
            let data = res.data || [];
            data = data.map(g => ({
              ...g,
              id: (g.name || '').toLowerCase().replace(/\s/g, '-')
            }))

            commit('SET_MENU', { data, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getMenu: (state) => (locale) => {
        return state.menu[locale] || [];
      },
    }
  }
}